module.exports = __webpack_public_path__ + "static/img/05-zhihuiwnagyinyun.542dd6e1.png";